<script>
    import R, {LOADER} from "../lib/requests";
    import Modal from '../components/modal/Modal.svelte';
    import Checkbox from "../components/controls/Checkbox.svelte";
    import Editor from "../components/Editor.svelte";
    import TourImages from "./TourImages.svelte";
    import {setFocusTo} from "../lib/lib";
    import Notifier from "../stores/notifier";
    import TimeControl from "../components/controls/TimeControl.svelte";
    import FileUploader from "../components/FileUploader.svelte";

    export let tourId = null;
    export let updateCallback;
    export let closeCallback;

    let tour = null;
    let totalImagesToUpload = 0;
    let imageUploadIndex = 0;
    let tourSaved = false;

    const initialize = () => {
        if (tourId == 0) {
            tour = {
                id: 0,
                name: '',
                description: '',
                content: '',
                start_time: null,
                duration: null,
                on_site: 1,
                is_hot: 0,
                is_active: 1,
                images: [],
            }
            setFocusTo('tourName');
        } else {
            load();
        }
    }

    const load = () => {

        const onSuccess = result => {
            tour = result;
            setFocusTo('tourName');
        };

        const onFailure = err => {
        };

        R.handle(R.tour.details, tourId, onSuccess, onFailure, LOADER.POPUP);
    };

    const save = () => {
        const onSuccess = result => {
            tour.id = result.id;
            tourId = result.id;
            totalImagesToUpload = tour.images.filter(i => i.id == 0).length;
            tourSaved = true;
            updateCallback();
            Notifier.showMessage("Tour updated");
        }

        const onFailure = err => {
            console.log(err);
        };


        tour.name = tour.name.trim();
        if (!tour.name) {
            Notifier.showError("Type the name of the tour");
            setFocusTo("tourName");
            return;
        }

        let action = tourId == 0 ? 'create' : 'edit';
        R.handle(R.tour[action], tour, onSuccess, onFailure, LOADER.POPUP);
    }

    const close = () => {
        closeCallback();
    }

    const onContentChange = ({detail}) => {
        tour.content = detail.text;
    }

    // Images
    const imageUploaded = ({detail}) => {
        tour.images = tour.images;
        uploadNextImage();
    }

    const imageUploadError = ({detail}) => {
        totalImagesToUpload = 0;
        imageUploadIndex = 0;
    }
    const uploadNextImage = () => {
        let image = tour.images.find(obj => obj.id == 0);
        if (image) {
            image.upload = true;
            image.tour_id = tour.id;
            tour.images = tour.images;
            imageUploadIndex++;
        } else {
            totalImagesToUpload = 0;
            imageUploadIndex = 0;
            tourSaved = true;
            Notifier.showMessage("Tour images uploaded");
        }
    }

    initialize();

    $: if (tourSaved) {
        tourSaved = false;
        if (totalImagesToUpload > 0) {
            imageUploadIndex = 0;
            uploadNextImage();
        }
    }
</script>

{#if tour}
    <Modal modalLg title="Tour" on:close="{ close }">
        <div slot="body">
            <div class="row">
                <div class="col-md-9">
                    <div class="form-group">
                        <label>Name</label>
                        <input type="text" class="form-control" id="tourName" bind:value="{ tour.name }">
                    </div>
                    <div class="form-group">
                        <label>Description</label>
                        <textarea class="form-control" bind:value="{ tour.description }"></textarea>
                    </div>
                    <div class="form-group">
                        <Editor text="{ tour.content }" on:change={ onContentChange }/>
                    </div>
                    <div class="row">
                        <div class="col-md-4 form-group">
                            <label>Time start</label>
                            <TimeControl bind:time={tour.start_time}/>
                        </div>
                        <div class="col-md-4 form-group">
                            <label>Duration (in minutes)</label>
                            <input type="number" class="form-control" bind:value={tour.duration}/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 form-group">
                            <Checkbox label="Active tour" bind:checked={ tour.is_active }/>
                        </div>
                        <div class="col-md-4 form-group">
                            <Checkbox label="On site" bind:checked={ tour.on_site }/>
                        </div>
                        <div class="col-md-4 form-group">
                            <Checkbox label="Hot tour" bind:checked={ tour.is_hot }/>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <TourImages tourId="{ tour.id }" bind:images={tour.images}
                                on:upload_complete="{ imageUploaded }"
                                on:upload_error="{ imageUploadError }"/>
                </div>
            </div>
            <hr>
            <div class="text-end">
                <div class="btn btn-link me-2" on:click="{ () => close() }">Close</div>
                <button class="btn btn-primary px-4" on:click="{ save }">Save</button>
            </div>
        </div>
    </Modal>

    {#if imageUploadIndex > 0}
        <FileUploader currentIndex={imageUploadIndex} totalFiles={totalImagesToUpload}/>
    {/if}
{/if}